export const TAKE: number | 'all' = 100